import * as React from 'react';
import { pickupStyles } from './pickup.styles';
// import Paginator from '../../common/paginator';
import moment from 'moment';
import {
    Button,
    DatePicker,
    message,
    Popover,
    Table,
    Modal,
    Tabs,
    Select,
    Divider,
} from 'antd';
import {
    EllipsisOutlined,
    InfoCircleOutlined,
    SettingOutlined,
    CloseCircleOutlined,
    CheckCircleOutlined,
    ExclamationCircleFilled,
    EditOutlined,
    DownloadOutlined,
} from '@ant-design/icons';
import {
    bulkPrint,
} from '../../../network/consignments.api';
import { HocOptions } from '../../common/generic-hoc.types';
import { StylesProps } from '../../../theme/jss-types';
import {
    downloadPickups,
    fetchSummaryPickups,
    markPickupAsSuccess,
    cancelCarrierPickups,
    getPickupConsignments,
} from '../../../network/pickup.api';
import PickupFilters from './pickup-filters';
import { BucketKeys, ReduxStore } from '../../../reducers/redux.types';
import { bindActionCreators } from 'redux';
import {
    applyFilters,
    setFilters,
    setPagination,
} from '../../../actions/generic-action';
import { Buckets, NextOrPrev, Pagination } from '../../../library/Types';
import { loadPickups } from '../../../actions/pickup-actions';
import GenericHoc from '../../common/generic-hoc';
import { getDownloadsRoute } from '../../../routing/routing-helper';
import { RouteChildrenProps } from 'react-router';
import {
    Master,
    PickupBucketKeys,
    PickupColumn,
    PickupColumns,
} from '../../../types/master-data-types';
import PickupSettings from '../../settings/pickup-settings';
import { uniqBy } from 'lodash';
import { paginationOptions } from '../../../library/constants';
import { PickupBuckets, pickupConsignmentColumns } from './pickups.constants';
import { useTranslation } from 'react-i18next';
import GalleryModal from '../../common/gallery-modal';
import Helper from 'library/Helper';
import Loader from 'components/common/Loader';
import CreatePickup from '../create-pickup/create-pickup';
// import CreatePickup from '../create-pickup/create-pickup';
import FixedHeaderTable from 'components/common/FixedHeaderTable/FixedHeaderTable';
import Paginator from 'components/common/paginator';

interface PickupProps
    extends StylesProps<ReturnType<typeof pickupStyles>>,
    RouteChildrenProps {
    master: Master;
    setfilters: (bucketId: BucketKeys, filters: any) => void;
    applyfilters: (bucketId: BucketKeys) => void;
    filters: Record<string, any>;
    loading: boolean;
    loadpickups: () => void;
    pickups: any[];
    pickupCustomerConfig: any;
    defaultFilters: Record<string, any>;
    // uiTheme: ThemeType;
    setpagination: (bucketId: Buckets.PICKUPS, newPagination: Partial<Pagination>) => void;
    pagination: Pagination;
}
interface GalleryModalData {
    images: string[];
    videos: string[];
}

const {
    useState,
    useEffect,
} = React;

const PickupPage = (props: PickupProps) => {
    const [bucketSelected, setBucketSelected] = useState<PickupBucketKeys>('customer_portal_all');
    const [moreFilterVisible, setMoreFiltersVisible] = useState<boolean>(false);
    const [summary, setSummary] = useState<any>({});
    const [downloading, setDownloading] = useState<boolean>(false);
    const [bulkPrinting, setBulkPrinting] = useState<boolean>(false);
    const [settingsVisible, setSettingsVisible] = useState<boolean>(false);
    const [toggle, setToggle] = React.useState<boolean>(true);
    const [isGalleryModalVisible, setIsGalleryModalVisible] = React.useState(false);
    const [pickupConsignments, setPickupConsignments] = React.useState<string[] | null>(null);
    const [galleryModalData, setGalleryModalData] = React.useState<GalleryModalData>({ images: [], videos: [] });
    const [loadConsignments, setloadConsignments] = useState<boolean>(false);
    const [showConsignmentsModal, setShowConsignmentsModal] = useState<boolean>(false);
    const [actionModal, setActionModal] = React.useState<any>({});
    const [isLoading, setIsLoading] = React.useState<boolean>(false);
    const [drawerVisible, setDrawerVisible] = useState(false);
    const [editData, setEditData] = useState(null);
    const [filterHeight, setFilterHeight] = React.useState(0);
    const filtersRef = React.useRef<HTMLDivElement>(null);
    const {
        classes,
        master,
        filters,
        setfilters,
        applyfilters,
        loadpickups,
        pickups,
        loading,
        history,
        defaultFilters,
        pickupCustomerConfig,
        pagination,
        setpagination,
    } = props;
    const { t } = useTranslation();

    const { config } = master;

    const loadSummary = async () => {
        const response = await fetchSummaryPickups({
            dateFilterColumn: 'created_at',
            fromDate: moment(filters.fromDate).format('YYYY-MM-DD'),
            toDate: moment(filters.toDate).format('YYYY-MM-DD'),
            bucketIds: Object.keys(PickupBuckets),
            isRiderAssigned: filters.isRiderAssigned === 'ALL' ? undefined : filters.isRiderAssigned === 'ASSIGNED',
            loadType: filters.courierType === 'ALL' ? undefined : filters.courierType,
        });
        if (response.isSuccess) {
            setSummary(response?.data || {});
        } else {
            message.error(response.errorMessage);
            setSummary({});
        }
    };
    const showBucketCount = master?.config?.customer_portal_config?.fetch_customer_portal_bucket_count;
    const customerProperties = master?.properties;
    const enable_customer_config = master?.parts_to_show?.enable_customer_config || false;
    let success_pickup_creation = true;
    let cancel_pickup_creation = true;
    let edit_pickup_creation = false;
    if (customerProperties && enable_customer_config) {
        success_pickup_creation = customerProperties?.success_pickup_creation;
        cancel_pickup_creation = customerProperties?.cancel_pickup_creation;
        edit_pickup_creation = customerProperties?.edit_pickup_creation;
    }

    useEffect(() => {
        loadpickups();
        loadSummary();
    }, [filters, toggle]);

    React.useLayoutEffect(() => {
        if (filtersRef?.current?.clientHeight !== filterHeight) {
            setFilterHeight(filtersRef?.current?.clientHeight || 0);
        }
    });

    const renderText = (text: string | number | null) => {
        if (!text || text === null) {
            return <div className={classes.cellNa}>—na—</div>;
        }
        return (
            <div
                className={classes.cellValue}
            >
                {text}
            </div>
        );
    };
    const renderGallery = (imageArray: any[], videoArray: any[]) => {
        if (!imageArray || !videoArray) return 'Not Available';
        return (
            <a onClick={() => {
                setGalleryModalData({
                    images: imageArray,
                    videos: videoArray,
                });
                setIsGalleryModalVisible(true);
            }}
            >
                View
            </a>
        );
    };

    // const handlePrintLabel = (fileBuffer: any, fileName: string) => {
    //   if (fileBuffer.isSuccess) {
    //     const name = fileBuffer.filename || fileName;
    //     Helper.downloadFileData(
    //       fileBuffer.data,
    //       name,
    //       true,
    //     );
    //     message.success('Success');
    //   } else {
    //     message.error(fileBuffer.errorMessage);
    //   }
    // };

    // const handlePrint = async (row: any) => {
    //   const response = await bulkPrint({
    //     referenceNumbers: [row.reference_number],
    //   });
    //   handlePrintLabel(response, 'Print');
    // };

    // const renderDropdown = (row: any) => {
    //   return (
    //     <PrinterOutlined onClick={() => handlePrint(row)} />
    //   );
    // };

    const renderDestinationDetailsTable = (data: any) => {
        const columns = [
            {
                title: 'City',
                dataIndex: 'city',
                key: 'city',
            },
            {
                title: 'Quantity',
                dataIndex: 'quantity',
                key: 'quantity',
            },
            {
                title: 'Units',
                dataIndex: 'units',
                key: 'units',
            },
        ];
        return (
            <Table
                dataSource={data}
                columns={columns}
                pagination={false}
                style={{
                    margin: '0 10px',
                }}
            />
        );
    };

    const handlePickupEdit = (row: any) => {
        setEditData(row);
        setDrawerVisible(true);
    };

    const closeDrawer = () => {
        setDrawerVisible(false);
        setEditData(null);
    };

    const fetchPickupConsignment = async (row: any) => {
        setShowConsignmentsModal(true);
        setloadConsignments(true);
        const response = await getPickupConsignments({ taskId: row.taskId });
        if (response && response.isSuccess) {
            setPickupConsignments(Helper.isValidArray(response?.data) ? response?.data : []);
        } else {
            message.error(response.errorMessage);
            setPickupConsignments([]);
        }
        setloadConsignments(false);
    };

    const handleCloseModal = () => {
        setPickupConsignments(null);
        setShowConsignmentsModal(false);
    };

    const renderConsignmentDetails = (row: any) => {
        return (
            <>
                {row.totalItems}
                <Button type="link" onClick={() => fetchPickupConsignment(row)}>
                    <InfoCircleOutlined />
                </Button>
            </>
        );
    };

    const renderDestinationDetails = (row: any) => {
        return (
            <Popover
                trigger="click"
                title="Destination Details"
                content={() => renderDestinationDetailsTable(row.destinationDetails)}
            >
                <InfoCircleOutlined />
            </Popover>
        );
    };

    const getAddress = (address: any) => {
        let result = address.name;
        result += ', ';
        result += address.addressLine1;
        result += ', ';
        result += address.addressLine2;
        result += ', ';
        result += address.cityName;
        result += ', ';
        result += address.stateName;
        return result;
    };

    const handleActionModal = (pickupId: string, action: string) => {
        setActionModal({
            pickupId,
            action,
            isVisible: true,
        });
    };

    const handlePickupSuccess = async (pickupId: string) => {
        const response = await markPickupAsSuccess({
            pickupId,
        });
        if (response.isSuccess) {
            message.success('Pickup has been marked as Success');
        } else {
            message.error(response.errorMessage);
        }
    };

    const handlePickupCancel = async (pickupId: string) => {
        const response = await cancelCarrierPickups({
            pickupId,
        });
        if (response.isSuccess) {
            message.success('Pickup has been marked as Cancelled');
        } else {
            message.error(response.errorMessage);
        }
    };

    const renderColumn = (text: any, row: any, column: string) => {
        const blackListedStatusForActions = ['SUCCESS', 'CANCELLED'];
        switch (column) {
            case 'task_reference_number':
                return renderText(row.pickupId);
            case 'total_weight':
                return renderText(row.totalWeight);
            case 'total_volume':
                return renderText(row.totalVolume);
            case 'length':
                return renderText(row.length);
            case 'width':
                return renderText(row.width);
            case 'height':
                return renderText(row.height);
            case 'pickup_address':
                return renderText(getAddress(row.pickupAddress));
            case 'pickup_date':
                return renderText(row.timeSlotStart ? moment(row.timeSlotStart).format('DD MMM, YYYY') : null);
            case 'pickup_slot':
                return renderText(
                    row.timeSlotStart
                        ? `${moment(row.timeSlotStart).format('HH:mm')}-${moment(row.timeSlotEnd).format('HH:mm')}` : null,
                );
            case 'closing_time':
                return renderText(row.closingTimeString);
            case 'number_of_shipments':
                return renderConsignmentDetails(row);
            case 'item_type':
                return renderText(row.courierType);
            case 'pickup_task_status':
                return renderText(row.pickupTaskStatus);
            case 'is_rider_assigned':
                return renderText(row.isRiderAssigned ? 'Yes' : 'No');
            case 'waybill_type':
                return renderText(row.waybillType);
            case 'destination_details':
                return renderDestinationDetails(row);
            case 'failure_reason':
                return renderText(row.pickupFailureReason);
            case 'pickup_created_at':
                return renderText(row.pickupTaskCreationTimestamp);
            case 'pickup_pincode':
                return renderText(row.pickupAddress.pincode);
            case 'pickup_city':
                return renderText(row.pickupAddress.cityName);
            case 'pickup_phone_number':
                return renderText(row.pickupAddress.phone);
            case 'completion_time':
                return renderText(row.completionTime);
            case 'pickup_type':
                return renderText(row.pickupType);
            case 'service_type_id':
                return renderText(row.serviceTypeId);
            case 'courier_partner_pickup_number':
                return renderText(row.courierPartnerPickupNumber);
            case 'service_time':
                return renderText(row.serviceTime);
            case 'description':
                return renderText(row.description);
            case 'proof_of_pickup_image':
                if (!row
                    || !(row.taskProofOfPickupImage
                        || (Array.isArray(row.taskProofOfPickupImageList) && row.taskProofOfPickupImageList.length))) {
                    return renderText('Not Available');
                }
                return renderGallery([row.taskProofOfPickupImage, ...row.taskProofOfPickupImageList], []);
            case 'actions':
                if (
                    (
                        pickupCustomerConfig?.pickup_type?.length
                        && !pickupCustomerConfig?.pickup_type?.includes('Open Pickup')
                    )
                    || blackListedStatusForActions.includes(row.pickupTaskStatus)
                ) {
                    return renderText(text);
                }

                return (
                    <div className={classes.confirmationModal}>
                        {success_pickup_creation && (
                            <CheckCircleOutlined
                                onClick={() => {
                                    handleActionModal(row.pickupId, 'success');
                                    // handlePickupSuccess(row.pickupId);
                                }}
                            />
                        )}
                        {cancel_pickup_creation && (
                            <CloseCircleOutlined
                                onClick={() => {
                                    handleActionModal(row.pickupId, 'cancel');
                                    // handlePickupCancel(row.pickupId);
                                }}
                            />
                        )}
                        {edit_pickup_creation && (
                            <EditOutlined
                                onClick={() => {
                                    if (
                                        (row.pickupTaskStatus === 'CREATED' || row.pickupTaskStatus === 'PENDING')
                                        && row.creationSource === 'business_booking_add_pickup'
                                    ) {
                                        handlePickupEdit(row);
                                    }
                                }}
                                style={{
                                    color: (row.pickupTaskStatus !== 'CREATED' && row.pickupTaskStatus !== 'PENDING')
                                        || row.isRiderAssigned || row.creationSource !== 'business_booking_add_pickup'
                                        ? 'lightgray' : 'inherit',
                                    pointerEvents: (row.pickupTaskStatus !== 'CREATED' && row.pickupTaskStatus !== 'PENDING')
                                        || row.isRiderAssigned || row.creationSource !== 'business_booking_add_pickup'
                                        ? 'none' : 'auto',
                                }}
                            />
                        )}
                    </div>
                );
            default:
                return renderText(text);
        }
    };

    const getWidth = (id: string) => {
        switch (id) {
            case 'proof_of_pickup_image':
            case 'item_type': return 100;
            case 'completion_time':
            case 'pickup_created_at':
            case 'pickup_address':
                return 200;
            default: return 80;
        }
    };

    const getFixed = (column: string) => {
        switch (column) {
            case 'actions': return 'right';
            case 'task_reference_number': return 'left';
            default: return undefined;
        }
    };

    const getColumns = (): any[] => {
        const pickup_column_list_by_bucket: PickupColumns<any> = config?.pickup_column_list_by_bucket || {};
        const columnLabels = [...(pickup_column_list_by_bucket?.pickup_all || [])];
        columnLabels.push({
            pretty_name: t('actions'),
            column_id: 'actions',
        });

        const columns: any = columnLabels.map((column: PickupColumn) => {
            return {
                key: column.column_id,
                title: column.column_id === 'completion_time' ? t('completion_time_pickup') : t(column.column_id),
                dataIndex: column.column_id,
                width: getWidth(column.column_id),
                ellipsis: true,
                fixed: getFixed(column.column_id),
                render: (text: string, row: any) => renderColumn(text, row, column.column_id),
                isSortable: ['pickup_created_at', 'pickup_date'].includes(column.column_id),
            };
        });
        return columns;
    };

    const handleColumnSort = (type: string, column: any) => {
        const newFilters = {
            ...filters,
            sortBy: column.key,
            descendingOrder: type === 'desc',
        };
        setfilters(Buckets.PICKUPS, newFilters);
        applyfilters(Buckets.PICKUPS);
    };

    const renderTable = () => {
        return (
            <FixedHeaderTable
                bordered={false}
                pagination={false}
                loading={loading}
                rowKey={(row: any) => row.id}
                columns={getColumns()}
                dataSource={pickups || []}
                style={{
                    flexGrow: 1,
                    background: '#ffffff',
                }}
                handleSort={handleColumnSort}
                sortBy={filters.sortBy || filters.dateType}
                descendingOrder={filters.descendingOrder}
            />
        );
    };

    const handleBucketChange = (bucket: PickupBucketKeys) => {
        if (bucket === bucketSelected) {
            return;
        }
        setfilters(Buckets.PICKUPS, {
            ...filters,
            status: bucket === 'customer_portal_all' ? undefined : bucket.substring(16),
        });
        applyfilters(Buckets.PICKUPS);
        setBucketSelected(bucket);
    };

    const getTabName = (bucket: string) => {
        let countClass = classes.count;
        if (bucket === bucketSelected) {
            countClass = [classes.count, classes.countSelected].join(' ');
        }
        return (
            <>
                <span style={{ color: bucket === bucketSelected ? '#111' : '#666' }}>
                    {t(bucket)}
                </span>
                {
                    showBucketCount
                        ? (<span className={countClass}>{summary[bucket] || 0}</span>)
                        : null
                }
            </>
        );
    };

    const renderBucket = (bucket: string) => {
        return (
            <Tabs.TabPane
                tab={getTabName(bucket)}
                key={bucket}
            />
        );
    };


    const renderBuckets = () => {
        return (
            <div className={classes.tabsContainer}>
                <Tabs
                    className={classes.bucketRow}
                    activeKey={bucketSelected}
                    onChange={(bucket) => handleBucketChange(bucket as PickupBucketKeys)}
                    moreIcon={(
                        <span>
                            <EllipsisOutlined />
                        </span>
                    )}
                >
                    {Object.keys(PickupBuckets).map((bucket) => renderBucket(bucket as PickupBucketKeys))}
                </Tabs>
            </div>
        );
    };

    const isMoreFilterAdded = () => {
        const dateKeys = ['fromDate', 'toDate'];
        const isFilterApplied = Object.keys(filters).some((filter) => {
            if (dateKeys.includes(filter)) {
                return false;
            }
            return filters[filter] !== defaultFilters[filter];
        });
        return isFilterApplied;
    };

    const handleSettingsClose = (refresh?: boolean) => {
        setSettingsVisible(false);
        if (refresh) {
            setToggle(!toggle);
        }
    };
    const renderSettingsModal = () => {
        if (!settingsVisible) {
            return null;
        }
        const options = uniqBy(config?.full_pickup_column_list || [], 'column_id');
        const columns: Record<string, PickupColumn> = {};
        options.forEach((item) => {
            columns[item.column_id] = item;
        });
        return (
            <PickupSettings
                bucketSelected="pickup_all"
                filterObject={{ columns }}
                onClose={(refresh?: boolean) => handleSettingsClose(refresh)}
            />
        );
    };

    const getFilterValue = (value: string) => {
        if (value === 'ALL') {
            return undefined;
        }
        return value;
    };

    const getRiderAssigned = (value: string) => {
        if (value === 'ALL') {
            return undefined;
        }
        return value === 'ASSIGNED';
    };

    const handleDownload = async () => {
        const dateFormat = 'DD/MM/YYYY';
        setDownloading(true);
        const response = await downloadPickups({
            clientName: 'ALL',
            courierName: 'ALL',
            fromDate: moment(filters.fromDate).format(dateFormat),
            toDate: moment(filters.toDate).format(dateFormat),
            sortBy: filters.sortBy,
            courierType: getFilterValue(filters.courierType),
            isRiderAssigned: getRiderAssigned(filters.isRiderAssigned),
            status: getFilterValue(filters.status),
        });
        if (response.isSuccess) {
            message.success('Downloaded Successfully');
            history.push(getDownloadsRoute());
        } else {
            message.error(response.errorMessage);
        }
        setDownloading(false);
    };

    const renderDownload = () => {
        return (
            <Button
                type="primary"
                loading={downloading}
                className={classes.downloadBtn}
                onClick={handleDownload}
                icon={<DownloadOutlined />}
            >
                {t('download')}
            </Button>
        );
    };

    const handleBulkPrint = async () => {
        setBulkPrinting(true);
        const response = await bulkPrint({});
        if (response.isSuccess) {
            message.success('Success');
        } else {
            message.error(response.errorMessage);
        }
        setBulkPrinting(false);
    };

    const renderPrint = () => {
        return (
            <Button
                type="primary"
                style={{ display: 'none' }}
                className={classes.downloadBtn}
                loading={bulkPrinting}
                onClick={handleBulkPrint}
            >
                {t('bulk_print')}
            </Button>
        );
    };

    const renderSettings = () => {
        return (
            <SettingOutlined
                className={classes.settingIcon}
                onClick={() => setSettingsVisible(true)}
            />
        );
    };

    const disabledDate = (current: any) => {
        return current && current > moment().endOf('day');
    };

    const renderRangePicker = () => {
        return (
            <div className={classes.filter}>
                <DatePicker.RangePicker
                    value={[moment(filters.fromDate), moment(filters.toDate)]}
                    allowClear={false}
                    allowEmpty={[false, false]}
                    disabledDate={disabledDate}
                    dropdownClassName={classes.dateRange}
                    placeholder={['Select Start Date', 'Select End Date']}
                    ranges={{
                        Today: [moment(), moment()],
                        'Last 7 days': [moment().subtract(6, 'day'), moment()],
                        'Last 30 days': [moment().subtract(29, 'day'), moment()],
                    }}
                    onChange={(value) => {
                        if (!(value && value[0] && value[1])) return;
                        const newFilters = {
                            ...filters,
                        };
                        if (value[1].isSame(filters.toDate)) {
                            if (moment(filters.toDate).diff(value[0], 'days') > 30) {
                                const toDate = moment(value[0]).add(30, 'd');
                                newFilters.toDate = toDate.unix() * 1000;
                                newFilters.fromDate = moment(value[0]).unix() * 1000;
                            } else {
                                newFilters.toDate = moment(value[1]).unix() * 1000;
                                newFilters.fromDate = moment(value[0]).unix() * 1000;
                            }
                        } else if (value[0].isSame(filters.fromDate)) {
                            if (moment(value[1]).diff(value[0], 'days') > 30) {
                                const fromDate = moment(value[1]).subtract(30, 'd');
                                newFilters.fromDate = fromDate.unix() * 1000;
                                newFilters.toDate = moment(value[1]).unix() * 1000;
                            } else {
                                newFilters.toDate = moment(value[1]).unix() * 1000;
                                newFilters.fromDate = moment(value[0]).unix() * 1000;
                            }
                        } else {
                            newFilters.fromDate = moment(value[0]).unix() * 1000;
                            newFilters.toDate = moment(value[1]).unix() * 1000;
                        }
                        setfilters(Buckets.PICKUPS, newFilters);
                        applyfilters(Buckets.PICKUPS);
                    }}
                />
            </div>
        );
    };

    const renderDateFilter = () => {
        return (
            <div className={classes.dateFilter}>
                {renderRangePicker()}
            </div>
        );
    };

    const renderRightFilters = () => {
        return (
            <div className={classes.rightFilters}>
                {renderDownload()}
                {renderPrint()}
                {renderDateFilter()}
                <Divider
                    type="vertical"
                    style={{
                        width: 1,
                        height: 24,
                        backgroundColor: '#E0E0E0',
                        borderRadius: 4,
                    }}
                />
                {renderSettings()}
            </div>
        );
    };

    const renderFilters = () => {
        return (
            <div className={classes.filters} ref={filtersRef}>
                {renderBuckets()}
                {renderRightFilters()}
            </div>
        );
    };

    const renderMoreFilters = () => {
        if (!moreFilterVisible) {
            return null;
        }
        return (
            <PickupFilters
                resetVisible={isMoreFilterAdded()}
                onClose={() => setMoreFiltersVisible(false)}
            />
        );
    };

    const renderConsignmentDetailsForPickup = () => {
        return (
            <Modal
                title="Consignments"
                width={400}
                centered
                visible={showConsignmentsModal}
                onCancel={handleCloseModal}
                footer={null}
            >
                <Table
                    dataSource={(pickupConsignments || []).map((referenceNumber: string, idx: number) => ({
                        referenceNumber,
                        serialNumber: idx + 1,
                    }))}
                    rowKey={(row) => row.referenceNumber}
                    loading={loadConsignments}
                    columns={pickupConsignmentColumns}
                    pagination={false}
                />
            </Modal>
        );
    };

    const handleModalSubmit = async (shouldPerformAction: boolean) => {
        if (!shouldPerformAction) {
            setActionModal({
                action: null,
                pickupId: null,
                isVisible: false,
            });
            return;
        }
        setIsLoading(true);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        if (actionModal.action === 'success') {
            await handlePickupSuccess(actionModal.pickupId);
        } else if (actionModal.action === 'cancel') {
            await handlePickupCancel(actionModal.pickupId);
        }
        setIsLoading(false);
        setActionModal({
            action: null,
            pickupId: null,
            isVisible: false,
        });
    };

    const renderCloseConfirmModal = (shouldLoad: boolean, actionModalConfig: any) => {
        const { action, isVisible } = actionModalConfig;

        return (
            <Modal
                title={(
                    <div style={{ fontWeight: 600 }}>
                        <ExclamationCircleFilled style={{ color: '#EA2626', fontSize: 16 }} />
                        &nbsp;
                        {t('Confirm Action')}
                    </div>
                )}
                visible={isVisible}
                onCancel={() => handleModalSubmit(false)}
                footer={[
                    <Button
                        key="back"
                        type="text"
                        onClick={() => handleModalSubmit(false)}
                        disabled={shouldLoad}
                    >
                        {t('No')}
                    </Button>,
                    <Button
                        key="submit"
                        type="primary"
                        disabled={shouldLoad}
                        style={{ padding: shouldLoad ? '4px 20px' : '4px 15px' }}
                        onClick={() => handleModalSubmit(true)}
                    >
                        { shouldLoad ? <Loader zIndex={1500} size="16" /> : t('Yes') }
                    </Button>,
                ]}
            >
                {`Are you sure you want to mark this pickup as ${action}?`}
            </Modal>
        );
    };
    const handleSuccess = (data:any) => {
        // Handle the success event, e.g., show a success message
        console.log('Pickup created successfully:', data);
        // Close the drawer
        closeDrawer();
    };

    const handlePagination = (nextOrPrev: NextOrPrev, resultPerPage?: number | undefined) => {
        const { currentPageNumber } = pagination;
        let newPageNumber = currentPageNumber;
        if (nextOrPrev === 'first') {
            newPageNumber = 1;
        } else if (nextOrPrev === 'next') {
            newPageNumber = currentPageNumber + 1;
        } else {
            newPageNumber = currentPageNumber - 1;
        }
        const newPagination = {
            ...pagination,
            nextOrPrev,
            currentPageNumber: newPageNumber,
        };
        if (resultPerPage) {
            newPagination.resultPerPage = resultPerPage;
        }
        setpagination(Buckets.PICKUPS, newPagination);
        setToggle(!toggle);
    };

    const renderPaginator = () => {
        return (
            <div className={classes.paginationGroup}>
                <div>
                    {t('showing')}
                    <Select
                        className={classes.resultPerPage}
                        value={pagination.resultPerPage?.toString()}
                        onChange={(val: string) => handlePagination('first', val as any)}
                        options={paginationOptions}
                        dropdownMatchSelectWidth={false}
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                    />
                    {t('rows_per_page')}
                </div>
                <Paginator
                    currentPageNumber={pagination.currentPageNumber}
                    isNextPresent={pagination.isNextPresent}
                    onNextClick={() => handlePagination('next')}
                    onPrevClick={() => handlePagination('prev')}
                    onFirstClick={() => handlePagination('first')}
                />
            </div>
        );
    };

    const renderFooter = () => {
        return (
            <div className={classes.footer}>
                {renderPaginator()}
            </div>
        );
    };

    return (
        <div className={classes.main}>
            {renderFilters()}
            {renderTable()}
            {renderFooter()}
            {renderMoreFilters()}
            {renderSettingsModal()}
            {isGalleryModalVisible && (
                <GalleryModal
                    isVisible={isGalleryModalVisible}
                    imageVideoGalleryData={galleryModalData}
                    handleModalClose={() => { setIsGalleryModalVisible(false); }}
                />
            )}
            {renderConsignmentDetailsForPickup()}
            {renderCloseConfirmModal(isLoading, actionModal)}
            {drawerVisible && (
                <CreatePickup
                    config={master?.config}
                    editPickupData={editData}
                    allowEdit
                    visible={drawerVisible}
                    loadpickups={loadpickups}
                    onClose={closeDrawer}
                    setSuccess={handleSuccess}
                />
            )}
        </div>
    );
};

const mapStateToProps = (state: ReduxStore) => {
    const { generic, master, uiTheme } = state;
    const { PICKUPS } = generic;
    const pickupCustomerConfig = master?.config?.customer_portal_ops_config?.pickup_configuration?.config_value || {};
    const {
        appliedFilters,
        loading,
        data,
        defaultFilters,
        pagination,
    } = PICKUPS;
    return {
        master,
        loading,
        pickupCustomerConfig,
        defaultFilters,
        pickups: data,
        filters: appliedFilters,
        uiTheme,
        pagination,
    };
};

const mapDispatchToProps = (dispatch: any) => {
    const actions = {
        setfilters: setFilters,
        applyfilters: applyFilters,
        loadpickups: loadPickups,
        setpagination: setPagination,
    };
    return bindActionCreators(actions, dispatch);
};

const hocConfig: HocOptions = {
    connectJss: {
        useJss: true,
        styleSheet: pickupStyles,
    },
    connectRedux: {
        useRedux: true,
        mapStateToProps,
        mapDispatchToProps,
    },
    connectRouter: true,
    connectTranslession: true,
};

const Pickups = GenericHoc(hocConfig)(PickupPage);
export default Pickups;
